import { render, staticRenderFns } from "./LimitProductSpecificSku.vue?vue&type=template&id=40fc406e&scoped=true&"
import script from "./LimitProductSpecificSku.vue?vue&type=script&lang=js&"
export * from "./LimitProductSpecificSku.vue?vue&type=script&lang=js&"
import style0 from "./LimitProductSpecificSku.vue?vue&type=style&index=0&id=40fc406e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc406e",
  null
  
)

export default component.exports